var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8517_6561)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    fill: "#E6F6EE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8517_6561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6112 11.3885C24.76 9.53718 21.7481 9.53718 19.8968 11.3885L17.1381 14.1471C16.6567 14.6285 16.2666 15.2427 16.0152 15.9926C16.011 15.994 16.0069 15.9961 16.0027 15.9975C15.4309 17.7176 15.8646 19.5881 17.1381 20.8616C17.5186 21.2421 17.9663 21.5554 18.4511 21.7867L18.6302 21.6077C19.2494 20.9884 19.2494 19.9887 18.6302 19.3695C17.6006 18.3399 17.6006 16.6687 18.6302 15.6392L21.3889 12.8805C22.4184 11.851 24.0896 11.851 25.1191 12.8805C26.1487 13.9101 26.1487 15.5812 25.1191 16.6108L23.0244 18.7055C23.3037 19.5691 23.3629 20.4836 23.2277 21.3737C23.4483 21.22 23.6606 21.0535 23.8525 20.8616L26.6112 18.1029C28.4625 16.2516 28.4625 13.2397 26.6112 11.3885Z",
    fill: "#05954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8685 17.1313C20.488 16.7508 20.0404 16.4375 19.548 16.2136L19.3764 16.3853C18.7572 17.0045 18.7572 18.0042 19.3764 18.6234C20.4059 19.653 20.4059 21.3242 19.3764 22.3537C18.5049 23.2251 17.4417 24.2885 16.6109 25.1194C15.5813 26.149 13.9102 26.149 12.8806 25.1194C11.8511 24.0899 11.8511 22.4187 12.8806 21.3892L14.9821 19.2874C14.7028 18.4238 14.6437 17.5093 14.7789 16.6192C14.5582 16.773 14.346 16.9394 14.154 17.1313L11.3885 19.897C9.53718 21.7483 9.53718 24.7602 11.3885 26.6115C13.2398 28.4628 16.2516 28.4628 18.103 26.6115L20.8685 23.8458C21.3499 23.3644 21.7399 22.7502 21.9913 22.0004C21.9956 21.999 21.9996 21.9968 22.0039 21.9954C22.5756 20.2753 22.142 18.4048 20.8685 17.1313Z",
    fill: "#05954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.345 24.5919L24.5989 23.8458C24.3927 23.6396 24.059 23.6396 23.8529 23.8458C23.6467 24.052 23.6467 24.3857 23.8529 24.5919L24.5989 25.3379C24.8051 25.5441 25.1388 25.5441 25.345 25.3379C25.5511 25.1317 25.5511 24.798 25.345 24.5919Z",
    fill: "#05954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1541 13.4009L13.408 12.6549C13.2018 12.4487 12.8681 12.4487 12.662 12.6549C12.4558 12.8611 12.4558 13.1948 12.662 13.4009L13.408 14.147C13.6142 14.3532 13.9479 14.3532 14.1541 14.147C14.3603 13.9408 14.3603 13.6071 14.1541 13.4009Z",
    fill: "#05954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2929 20.6715L26.2736 20.3982C25.992 20.3228 25.7028 20.4897 25.6274 20.7713C25.5519 21.0546 25.7207 21.3427 26.0004 21.4176L27.0197 21.6908C27.3013 21.7662 27.5905 21.5993 27.6659 21.3177C27.7406 21.0361 27.5745 20.7454 27.2929 20.6715Z",
    fill: "#05954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0063 16.5755L10.987 16.3023C10.7054 16.2269 10.4162 16.3937 10.3408 16.6753C10.2653 16.9586 10.4341 17.2467 10.7138 17.3216L11.7331 17.5948C12.0147 17.6702 12.3039 17.5034 12.3793 17.2218C12.4544 16.9398 12.2868 16.6491 12.0063 16.5755Z",
    fill: "#05954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6978 27.0128L21.4246 25.9935C21.3488 25.7108 21.06 25.5451 20.7784 25.6205C20.4968 25.6959 20.3299 25.9851 20.4053 26.2667L20.6786 27.286C20.7534 27.5658 21.0415 27.7345 21.3248 27.6591C21.6064 27.5836 21.7732 27.2944 21.6978 27.0128Z",
    fill: "#05954E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6017 11.7262L17.3284 10.7069C17.2534 10.4242 16.9638 10.2592 16.6822 10.3339C16.4006 10.4093 16.2337 10.6985 16.3091 10.9801L16.5824 11.9994C16.6071 12.0919 16.6552 12.1721 16.7186 12.2355C16.8476 12.3644 17.0399 12.4227 17.2286 12.3724C17.5102 12.2971 17.6771 12.0078 17.6017 11.7262Z",
    fill: "#05954E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8517_6561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8517_6561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGreen);
export default __webpack_public_path__ + "static/media/link-green.a64945c027f57d7e07b9209d78b02788.svg";
export { ForwardRef as ReactComponent };